module.exports = {
  siteTitle: 'Neurafarm | Enterprise Solutions',
  siteDescription:
    'Neurafarm is a smart farming company that utilizes the power of Machine Learning and other cutting-edge technology to improve productivity and resource use efficiency in the agriculture industry.',
  siteKeywords: '',
  siteUrl: 'http://neurafarm.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Neurafarm',
  location: 'Bandung, West Java',
  email: 'hi@neurafarm.com',
  github: 'https://github.com/bchiang7',
  twitterHandle: 'neurafarm',
  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/company/neurafarm/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/neurafarmofficial',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/neurafarm',
    },
  ],

  navLinks: [
    {
      name: 'About Us',
      url: '#about',
    },
    {
      name: 'The Project',
      url: '#projects',
    },
    {
      name: 'Steps & Timeline',
      url: '#timeline',
    },
    {
      name: 'Your Investment',
      url: '#investment',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  navHeight: 100,
  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
